export const SIDEBAR_WIDTH = 320

export const DEFAULT_CHARACTER_LIMIT = 5000

export const RECOMMENDATION_STATEMENT_CHARACTERS_LIMIT = 5000
export const RECOMMENDATION_ADDITIONAL_COMMENT_CHARACTERS_LIMIT = 2500

export const APPLICATION_STATEMENT_CHARACTER_LIMIT = 5000

export const REJECTED_NOTE_CHARACTER_LIMIT = 250
